// Save an axios blob response as a file (filename from Content-Disposition, else fallback).
export function saveBlobResponse(res, fallbackName) {
  const cd = res.headers?.['content-disposition'] || '';
  const m = /filename="?([^";]+)"?/.exec(cd);
  const url = URL.createObjectURL(res.data instanceof Blob ? res.data : new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url; a.download = m ? m[1] : fallbackName; a.click();
  URL.revokeObjectURL(url);
  return a.download;
}

export async function blobErrorDetail(err) {
  if (err.response?.data instanceof Blob) {
    try { return JSON.parse(await err.response.data.text())?.detail; } catch { return ''; }
  }
  return err.response?.data?.detail;
}
